<template>
  <div class="panel--wrapper">
    <AppSidebar :shouldToggle="mini" :currentPageWidth="currentPageWidth"></AppSidebar>
    <div class="w-100">
      <AppHeader @toggleSidebar="setIsToggle" :currentPageWidth="currentPageWidth"></AppHeader>
      <main :style="{paddingLeft : mini || 1200>currentPageWidth ? '100px' : '270px'}" class="pt-4 pr-4">
        <transition
          name="fade"
          mode="out-in"
        >
          <router-view></router-view>
        </transition>
      </main>
    </div>
  </div>
</template>

<script>
  import AppSidebar from './components/_layout/AppSidebar.vue';
  import AppHeader from './components/_layout/AppHeader.vue';

  export default {
    name: 'authPanel',
    components: {
      AppSidebar,
      AppHeader,
    },
    data() {
      return {
        drawer: true,
        mini: false,
        currentLang: 'PL',
        currentPageWidth: window.innerWidth,
      };
    },
    mounted() {
      this.shouldCollapse();
    },
    methods: {
      shouldCollapse() {
        const el = document.querySelector('.application--wrap');
        const observer = new ResizeObserver((entries) => {
          // eslint-disable-next-line no-restricted-syntax,prefer-const
          for (let entry of entries) {
            this.currentPageWidth = Math.floor(entry.contentRect.width);
          }
        });
        observer.observe(el);
      },
      changeLang(lang) {
        this.currentLang = lang;
      },
      setIsToggle(toggle) {
        this.mini = toggle;
      },
    },
  };
</script>

<style scoped>
  .panel--wrapper {
    display: flex;
    background: #F0F0F7;
    min-height: 100vh
  }
</style>
